import { createRoot } from 'react-dom/client'
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-500.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/inter/latin-700.css'
import { renderApp, renderStartupError } from '@/bootstrap'
import { loadRuntimeConfig, RuntimeConfigError } from '@/lib/config/runtime-config'
import '@/styles/globals.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root was not found')
}

const root = createRoot(rootElement)

loadRuntimeConfig().then(
  () => renderApp(root),
  (error: unknown) => {
    if (!(error instanceof RuntimeConfigError)) throw error
    console.error(error.message)
    renderStartupError(root, error.problems)
  },
)
